import {useQuery} from 'react-query';
import getCountries from '.';

const useGetCountries = () => {
  const {data, isLoading} = useQuery(['shop-card-detail'], getCountries);
  return {countriesLists: data, isLoading};
};

export default useGetCountries;
